/** A language the Muggle Test UI ships translations for, as its BCP 47 tag. */
export enum SupportedLocale {
  English = "en",
  SimplifiedChinese = "zh-CN",
  TraditionalChinese = "zh-TW",
}
